import React from 'react';
import { GroupDropIndicator } from '@atlaskit/navigation-system/side-nav-items/drag-and-drop/group-drop-indicator';
import { fg } from '@atlassian/jira-feature-gating';
import { useDropTargetForProjects } from '../../controllers/drop-target-for-projects.tsx';

type ProjectsDroppableGroupIndicatorProps = {
	children: React.ReactNode;
};

export const ProjectsDroppableGroupIndicator = (props: ProjectsDroppableGroupIndicatorProps) => {
	const { children } = props;
	const dropTarget = useDropTargetForProjects();
	if (fg('blu-6314-drag-and-drop-projects-sidebar-mouse')) {
		const { ref, state } = dropTarget;
		return (
			<GroupDropIndicator isActive={state === 'is-over'} ref={ref}>
				{children}
			</GroupDropIndicator>
		);
	}
	return props.children;
};
